import React from 'react';
import './Services.css';
import iconGooglePlay from '../assets/icon_googleplay.webp';
import iconAppStore from '../assets/icon_appstore.webp';
import iconXiaomi from '../assets/icon_xiaomi_getapps.png';
import iconOppo from '../assets/icon_oppo.webp';

const Services = () => {
  const services = [
    {
      icon: '🎮',
      title: 'Game Development',
      description: 'End-to-end hyper-casual game development from concept to launch, utilizing cutting-edge technologies and design principles.',
      features: ['Unity & React Native', 'Cross-platform compatibility', 'Optimized performance', 'Engaging gameplay mechanics']
    },
    {
      icon: '📊',
      title: 'Monetization Strategy',
      description: 'Advanced monetization solutions that maximize revenue while maintaining excellent user experience and retention.',
      features: ['Ad integration (AdMob, Unity Ads)', 'In-app purchases', 'Subscription models', 'Revenue optimization']
    },
    {
      icon: '🚀',
      title: 'Publishing & Marketing',
      description: 'Complete publishing services for Google Play and App Store with strategic marketing to boost visibility and downloads.',
      features: ['App Store Optimization', 'User acquisition campaigns', 'Performance analytics', 'Global market reach']
    }
  ];

  const platforms = [
    {
      name: 'Google Play',
      logo: iconGooglePlay,
      description: 'Optimized for Android devices with Google Play Services integration'
    },
    {
      name: 'App Store',
      logo: iconAppStore,
      description: 'Native iOS development with App Store guidelines compliance'
    },
    {
      name: 'Xiaomi GetApps',
      logo: iconXiaomi,
      description: 'Xiaomi ecosystem integration with optimized performance for MIUI'
    },
    {
      name: 'Oppo App Market',
      logo: iconOppo,
      description: 'ColorOS optimization and Oppo device compatibility'
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="services-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive solutions for hyper-casual game development, publishing, and monetization
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="platforms-section">
          <h3 className="platforms-title">Publishing Platforms</h3>
          <div className="platforms-grid">
            {platforms.map((platform, index) => (
              <div key={index} className="platform-card">
                <div className="platform-logo">
                  <img src={platform.logo} alt={`${platform.name} icon`} />
                </div>
                <h4 className="platform-name">{platform.name}</h4>
                <p className="platform-description">{platform.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
